import { Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import moment from "moment";
import { CoPresentRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const AttendenceChart = (props) => {
  const { t } = useTranslation();
  const [series, setSeries] = useState([]);

  const options = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        borderRadius: 5,
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    noData: {
      text: "Loading...",
    },
    fill: {
      type: "gradient",
      gradient: {
        inverseColors: true,
        gradientToColors: ["#6078ea"],
      },
    },
    xaxis: {
      categories: moment.weekdaysShort(),
      legend: {
        position: "right",
        offsetY: 40,
      },
      fill: {
        opacity: 1,
      },
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => val.toLocaleString() + " h",
        style: {
          fontSize: "14px",
        },
      },
    },
  };

  useEffect(() => {
    setSeries([
      {
        name: t("Attendance"),
        data: [2.3, 3.1, 4.0, 4.1, 4.0, 3.6, 3.2],
      },
    ]);

    return () => {
      setSeries([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Paper sx={{ padding: { xs: "10px", md: "15px" } }}>
      <h2 className="fs-18 tx-upp gray-color fw-4 m-0 d-flex">
        <CoPresentRounded color="primary" />
        &nbsp;&nbsp;
      </h2>

      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        width="100%"
        height="210"
      />
    </Paper>
  );
};

export default AttendenceChart;
